import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import InnerPage from '../components/InnerPage.jsx';
import PhotoGallery from '../components/PhotoGallery.jsx';
import { VIP_PHOTOS } from '../data/vipPhotos.js';

export default function VipServicePage() {
  useEffect(() => {
    document.title = 'VIP Lounge | Nouakchott Oumtounsy International Airport (NKC/GQNO)';
  }, []);

  return (
    <InnerPage
      slug="vip-service"
      heading="VIP Lounge"
      lead="Relax in our premium lounge, with comfort, hospitality, and priority services before your flight."
      banner="/images/vip_lounge/vip-lounge (1).jpg"
      section="services"
    >
      <section className="section inner-content">
        <div className="container inner-prose">
          <p className="inner-lead">
            Our VIP Lounge is in the <strong>boarding wait area</strong> and is open{' '}
            <strong>24/7</strong>, a calm space with comfortable seating and hospitality before your
            flight.
          </p>

          <section className="inner-block" aria-labelledby="vp-info">
            <h2 id="vp-info">Location &amp; hours</h2>
            <ul className="inner-checklist">
              <li>
                <strong>Name:</strong> VIP Lounge
              </li>
              <li>
                <strong>Location:</strong> boarding wait area
              </li>
              <li>
                <strong>Opening hours:</strong> 24/7
              </li>
            </ul>
          </section>

          <section className="inner-block" aria-labelledby="vp1">
            <h2 id="vp1">What&rsquo;s included</h2>
            <ul className="inner-checklist">
              <li>Premium lounge seating and quiet zones</li>
              <li>Hospitality and refreshments (per package)</li>
              <li>Meet &amp; greet from kerb or aircraft door</li>
              <li>Fast-track security and immigration where permitted</li>
              <li>Buggy or private escort for long walks</li>
            </ul>
          </section>

          <section className="inner-block" aria-labelledby="vp-gallery">
            <h2 id="vp-gallery">Lounge gallery</h2>
            <p>Click any photo to open a larger view and slide through the full set.</p>

            <PhotoGallery
              photos={VIP_PHOTOS}
              gridClass="gallery-grid gallery-grid--vip"
              galleryId="vipGallery"
              emptyNote="Lounge photos will appear here when available."
              openLabel={(i, total) => `Open VIP Lounge photo ${i + 1} of ${total}`}
              lightboxLabel="VIP Lounge photo viewer"
            />
          </section>

          <section className="inner-block inner-block--cta" aria-labelledby="vp2">
            <h2 id="vp2">Book</h2>
            <p>
              Request at least <strong>24 hours</strong> ahead; provide flight number, terminal, and
              passenger count.
            </p>
            <p>
              <Link className="btn btn--accent inner-cta__btn" to="/contact?topic=vip">
                Contact commercial desk
              </Link>
            </p>
          </section>

          <p className="inner-disclaimer" role="note">
            Airport and flight information on this website is provided for general guidance only and
            may change without notice. While Nouakchott Oumtounsy International Airport (NKC/GQNO)
            strives to keep content accurate and up to date, information may occasionally be
            incomplete, outdated, or incorrect. Always confirm flight schedules, check-in times,
            baggage allowances, facilities, services, and other travel requirements with your airline
            or the relevant authority before travelling. Entry, visa, customs, and health requirements
            should be verified with the relevant government authorities. Where flight times are shown,
            they are in <abbr title="Greenwich Mean Time">GMT</abbr> (Nouakchott).
          </p>
        </div>
      </section>
    </InnerPage>
  );
}
